module.exports = __webpack_public_path__ + "media/images/thumb-down-ffa51f76dd4bc0de5b98d35278c2c3ce.svg";